import { saleStatusHistory } from '@/config'

const detail = {
  line1: [
    {
      name: 'registerDate',
      text: 'storage.storage_register-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'status',
      text: 'common.common_status',
      component: 'SelectStatusStockAdjust',
      cols: 4
    },
    {
      name: 'storage',
      text: 'stock-adjust.stock-adjust_stock-adjust_adjustment-warehouse',
      component: 'SelectStorageName',
      hasDefault: false,
      cols: 5
    },
    {
      name: 'adjustReason',
      text: 'stock-adjust.stock-adjust_stock-adjust-reason',
      component: 'SelectStockAdjustReason',
      cols: 5
    }
  ],
  line2: [
    {
      name: 'storageAdjustInfo',
      text: 'storage.storage_stock-adjust-info',
      cols: 5
    },
    {
      name: 'productInfo',
      text: 'sale.sale_product-info',
      component: 'SearchProductNoAndProductCategory'
    }
  ]
}

export default { detail }
